interface CoordinatesLike {
  latitude?: number | null
  longitude?: number | null
}

export function hasMapCoordinates(
  location?: CoordinatesLike | null,
): location is { latitude: number; longitude: number } {
  return location?.latitude !== undefined &&
    location.latitude !== null &&
    location.longitude !== undefined &&
    location.longitude !== null
}
